import styled, { css } from 'styled-components';

export const GrowthLevelWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    grid-gap: ${theme.sz.s3};

    @media (min-width: ${theme.sz.md}) {
      justify-content: flex-start;
      flex-direction: column;
    }
    @media (max-width: ${theme.sz.md}) {
      width: fit-content;
    }
  `,
);

export const ToggleWrapper = styled.div<{ $withReplay?: boolean; $withLike?: boolean }>(
  ({ theme, $withReplay, $withLike }) => {
    let columns = '1fr 1fr';
    if ($withReplay && $withLike) {
      columns = 'repeat(4, max-content)';
    } else if ($withReplay) {
      columns = 'repeat(3, max-content)';
    }

    return css`
      display: grid;
      grid-template-columns: ${columns};
      grid-column-gap: ${({ theme }) => theme.sz.s2};

      span {
        display: flex;
      }

      // horizontally align difficult words icon with ignore icon
      & > span:first-child {
        justify-self: end;
        position: relative;
        top: ${theme.sz.s05};
      }

      @media (min-width: ${({ theme }) => theme.sz.md}) {
        margin: ${({ theme }) => theme.sz.s2} 0 0;
      }

      ${
        $withReplay &&
        css`
          align-self: center;
          box-sizing: border-box;
          width: fit-content;
          padding: ${theme.sz.s2} ${theme.sz.s4};
          border-radius: ${theme.bo.medium};
          background: linear-gradient(
            160deg,
            rgba(0, 0, 0, 0.62) 0%,
            rgba(0, 0, 0, 0.42) 55%,
            rgba(0, 0, 0, 0.28) 100%
          );
          /* Match Like: muted secondary60 reads as disabled on this dark strip. */
          button {
            color: ${theme.co.secondary0};
          }

          @media (min-width: ${theme.sz.md}) {
            padding: ${theme.sz.s4};
          }
        `
      }
    `;
  },
);

export const DifficultWordIconWrapper = styled.button<{
  $active?: boolean;
}>(
  ({ theme, $active }) => css`
    margin: 0;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    background-color: ${theme.co.neutral98};
    border-radius: ${theme.bo.round};
    border: 0;
    height: ${theme.sz.s10};
    width: ${theme.sz.s10};
    color: ${$active ? theme.co.secondary0 : theme.co.secondary60};
    cursor: pointer;

    &:hover:not(:disabled) {
      background-color: ${theme.co.neutral95};
      color: ${theme.co.secondary0};
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    svg {
      height: ${theme.sz.s6};
      width: ${theme.sz.s6};
    }
  `,
);
